// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "product".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { productMeasureUnitValues } from '@borradh-workspace/labels';
/** Response atom for the "product" table (1:1 with a DB row, on the wire). */
export const productAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    images: z.unknown().nullable(),
    barcode: z.string().nullable(),
    brandId: z.string().nullable(),
    measureUnit: z.enum(productMeasureUnitValues),
    measureAmount: z.number().nullable(),
    shortDescription: z.string().nullable(),
    description: z.string().nullable(),
    categoryId: z.string().nullable(),
    supplyPriceCents: z.number().nullable(),
    retailEnabled: z.boolean(),
    isMedication: z.boolean(),
    onlineEnabled: z.boolean(),
    shippable: z.boolean(),
    retailPriceCents: z.number().nullable(),
    teamMemberCommissionEnabled: z.boolean(),
    skus: z.unknown().nullable(),
    supplierId: z.string().nullable(),
    trackStock: z.boolean(),
    lowStockLevel: z.number().nullable(),
    reorderQuantity: z.number().nullable(),
    lowStockNotify: z.boolean(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=product.js.map